/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IStackItemStyles, IStackStyles, IStackTokens } from "office-ui-fabric-react/lib/Stack";
import { getTheme } from "office-ui-fabric-react/lib/Styling";
import styled from "styled-components";

import { IButtonStyles, IDropdownStyles, ITextStyles } from "@fluentui/react";

const theme = getTheme();

export const Main = styled.div`
  background-color: white;
  overflow-y: hidden;
  padding: 2.5rem;
  margin-top: 0.625rem;
  border-radius: 0.5rem;
  width: 100%;
`;

/**
 * The stack containing all of the form elements.
 */
export const formStackStyles: IStackStyles = {
  root: {
    margin: "1.5rem",
    marginBottom: "0",
  },
};

/**
 * Styles for stack item wrapping field.
 */
export const fieldItemStyles: IStackItemStyles = {
  root: { height: "35px", width: "47%" },
};

export const verticalStackTokens: IStackTokens = { childrenGap: 20 };
export const horizontalStackTokens: IStackTokens = { childrenGap: 40 };
export const buttonStackTokens: IStackTokens = { childrenGap: 16 };

export const buttonStyles: IButtonStyles = {
  root: {
    margin: "0px 2px 20px auto",
    width: "7.5rem",
  },
};

/**
 * Styles to highlight important text for the admin
 */
export const highlightTextStyles: ITextStyles = {
  root: {
    color: theme.palette.red,
  },
};

export const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    height: "37px",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
  },
  label: {
    width: "100%",
  },
  dropdown: {
    width: "100%",
    height: "100%",
  },
  title: {
    height: "37px",
    display: "flex",
    alignItems: "center",
  },
  caretDownWrapper: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
};

export const flexStackStyles: IStackStyles = {
  root: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1.5rem",
  },
};

export const SolidDivider = styled.hr`
  border-top: 1px solid ${theme.palette.neutralTertiaryAlt};
  width: 100%;
  width: calc(100% + 3rem);
  align-self: center;
  margin-left: -1.5rem; // negative margin needed to offset padding within container
`;
